import { RadioGroup, RadioGroupProps } from "@mui/material";

export interface CDataRadioGroupProps extends RadioGroupProps {}

export function CDataRadioGroup(props: CDataRadioGroupProps) {
  return <RadioGroup {...props} />;
}
